package er.prateek.crossly.config

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * The `links` section of [AppConfig] -- the canonical host used to build new outbound share
 * links, and the URL each platform's Settings > Privacy Policy opens.
 *
 * [host] only affects links Crossly *builds from now on* (challenge/result/app-share URLs).
 * It does **not** retarget anything the OS resolves before Remote Config has even loaded:
 * AndroidManifest.xml's deep-link `intent-filter` host, iOS's associated-domains entitlement,
 * or the domain `assetlinks.json`/`apple-app-site-association` are served from are all static,
 * build-time values. Pushing a different host here without also shipping a build with those
 * updated to match breaks deep-link handling rather than migrating it -- treat this field as
 * "what to bake into the next release", not a live switch.
 *
 * Every field has a compiled default equal to the current production values, and blank
 * strings are treated the same as a missing field -- so an empty override in the console
 * degrades to the compiled default rather than to a broken link.
 */
@Serializable
data class LinksConfig(
    val host: String = "crossly.erprateek.in",
    @SerialName("privacy_policy_android") val privacyPolicyAndroid: String =
        "https://crossly.erprateek.in/android-privacy-policy.html",
    @SerialName("privacy_policy_ios") val privacyPolicyIos: String =
        "https://crossly.erprateek.in/ios-privacy-policy.html",
    @SerialName("privacy_policy_web") val privacyPolicyWeb: String =
        "https://crossly.erprateek.in/privacy-policy.html",
) {
    companion object {
        val DEFAULT = LinksConfig()
    }
}
